import { Link as RouterLink } from "react-router-dom";
import { Button, Typography } from "@mui/material";
import { mapIntegrationRouteToTitle } from "../utils";
import { EmptyRow } from "~/components/data-table";
import { OrganizationScope, SpaceScope } from "~/hooks/useScope";
import { getIntegrationAddHref } from "~/pages/integrations/utils/integrationLinksUtils";

interface IntegrationsTableEmptyRowProps {
  scope: SpaceScope | OrganizationScope;
  integrationTypeId: string | undefined;
}

export function HostedIntegrationsTableEmptyRow({
  scope,
  integrationTypeId,
}: IntegrationsTableEmptyRowProps) {
  const title = mapIntegrationRouteToTitle(integrationTypeId);
  let url = getIntegrationAddHref({
    scope,
    integrationTypeId: integrationTypeId || "",
  });

  if (integrationTypeId === "managed") {
    url = `/space/integrations/add/mondoo/setup?${scope.params}`;
  }

  return (
    <EmptyRow>
      <Typography color="text.secondary" sx={{ mb: 3 }}>
        You currently don't have any {title} integrations. Get started by adding
        one.
      </Typography>
      {integrationTypeId !== "security_pipeline_github" && (
        <Button
          variant="contained"
          color="primary"
          component={RouterLink}
          to={url}
        >
          {`add ${title} integration`}
        </Button>
      )}
    </EmptyRow>
  );
}
